class ZoneModel{
    zoneId:number;
    name?: string;
    
    
}
export default ZoneModel;